<template>
  <v-container fluid class="pa-0">
    <v-row dense>
      <v-col cols="12" class="pa-0 ma-0">
          <cambiarPassword/>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>


import cambiarPassword from '@/components/CambiarPassword/cambiarPassword.vue';
export default {
  name: "cambiarPasswordView",
  components: {
    cambiarPassword,    
  },
  data: () => ({}),
  computed: {},
  methods: {
  },
};
</script>
